import {Component, Input, OnInit} from '@angular/core';
import {Shift} from '@app/core/models/shift.model';
import {QMIcon} from '@app/core/interfaces/q-m-icon.enum';
import {VIEW_TYPE} from '@app/modules/home/modules/schedule/components/planning-controls/planning-controls.component';
import {SetSelectedModel, SetSelectedShift} from '@app/core/store/actions/schedule.actions';
import {IAppState} from '@app/core/store/state/app.state';
import {Store} from '@ngrx/store';
import {Availability} from '@app/core/models/availability.model';
import {User} from '@app/core/models/user.model';
import {Group} from '@app/core/models/group.model';
import {EQOIcon, EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Observable} from 'rxjs';
import {selectUser} from '@app/core/store/selectors/session.selectors';
import {getCurrentState} from '@app/core/helpers';
import * as moment from 'moment';

@Component({
	selector: 'app-planning-shift',
	templateUrl: './planning-shift.component.html',
	styleUrls: ['./planning-shift.component.scss'],
})
export class PlanningShiftComponent implements OnInit {
	public QMIcons = QMIcon;
	public EQOIcons = EQOIcon;
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	public VIEW_TYPES = VIEW_TYPE;

	public _shift: Shift | undefined;
	@Input() public fromSchedule: boolean = true;

	@Input()
	public set shift(value: Shift | undefined) {
		this._shift = value;
		this.setTooltips();
	}

	@Input() public selectedModel: Group | User;

	@Input() public dateIndex: number;

	public _availabilities: Availability[] = [];

	@Input()
	public set availabilities(value: Availability[]) {
		this._availabilities = value;
		this.setTooltips();
	}

	@Input() public viewType: VIEW_TYPE;

	public user$: Observable<User> = this.store.select(selectUser);

	public problemsTooltip: string = '';
	public availabilitiesTooltip: string = '';

	constructor(
		public store: Store<IAppState>,
		public interService: InternationalizationService,
	) {
	}

	public editShift(shift: Shift | null): void {
		let date;
		if (shift === null) {
			const selectedDates = getCurrentState(this.store).schedule.selectedDates;
			date = selectedDates[this.dateIndex];
			this.store.dispatch(new SetSelectedModel(this.selectedModel));
		} else {
			date = moment(shift.visible_date);
		}
		this.store.dispatch(new SetSelectedShift(shift, date));
	}

	public ngOnInit(): void {
	}

	public setTooltips(): void {
		this.problemsTooltip = '';
		this.availabilitiesTooltip = '';
		if (this._shift) {
			this.problemsTooltip += this.interService.translate.instant('SCHEDULE.PROBLEMS') + ' (' + this._shift.punch_not_approved_reasons.length + '):\n';
			this._shift.punch_not_approved_reasons.forEach((pnar, index) => {
				this.problemsTooltip += (index + 1) + '. ' + this.interService.translate.instant('GLOBAL.PUNCH_NOT_APPROVED_REASONS.' + pnar) + '\n';
			});
		}
		const currentUser = getCurrentState(this.store).session.user;
		if (this._availabilities.length > 0 &&
			(currentUser.isAdmin() || this._availabilities[0].user.id === currentUser.id)
		) {
			this.availabilitiesTooltip += this.interService.translate.instant('SCHEDULE.AVAILABILITIES') + ' (' + this._availabilities.length + '):\n';
			this._availabilities.forEach((availability, index) => {
				this.availabilitiesTooltip += (index + 1) + '. ' + availability.reason + '\n';
			});
		}
	}

}
